import { useTranslation } from "react-i18next";
import { AppButton } from "@/shared/Components";
import type { Props } from "./types";

export const Desktop = ({ onClick }: Props) => {
  const { t } = useTranslation();

  return (
    <AppButton type="primary" onClick={onClick}>
      {t("passwordRecoveryPage.toLogin")}
    </AppButton>
  );
};
